import { Box, Container, Grid, Typography, List, ListItem, ListItemIcon, ListItemText, useTheme } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import localmap from '../../assets/locationImg.webp';
import SectionHeading from '../ui/SectionHeading';

const RegionsSection = () => {
  const theme = useTheme();

  const regionFeatures = [
    'Regional compliance built-in',
    'Adaptable to local market conditions',
    'Scalable for any size of ISP operation',
    'Regional service coverage mapping and planning'
  ];

  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.light : '#f8f9fa',
      }}
    >
      <Container>
        <SectionHeading
          overline="Built for Albania"
          title="Serving ISPs across Albania"
          subtitle="Tailored for Albanian ISPs with local expertise"
        />

        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: { xs: 4, md: 0 } }}>
              <Typography variant="h3" gutterBottom>
                Localized Features for Albanian Market
              </Typography>
              <Typography variant="body1" paragraph sx={{ color: theme.palette.text.secondary }}>
                SOLVENDA is designed specifically with Albanian ISPs in mind, addressing the unique challenges and requirements of the local market.
              </Typography>
              
              <List>
                {regionFeatures.map((feature, index) => (
                  <ListItem key={index} sx={{ py: 1, px: 0 }}>
                    <ListItemIcon sx={{ minWidth: '40px' }}>
                      <CheckCircleIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={feature} />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={localmap}
              alt="Albania ISP Coverage Map"
              sx={{
                width: '100%',
                borderRadius: 2,
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default RegionsSection; 